import { Group } from '@/types/core/Group';
import ModalHeader from '@components/presentational/CustomModal/ModalHeader';
import React, { useMemo } from 'react';
import Modal from '@components/presentational/CustomModal/Modal';
import GroupForm from '@components/app/GroupForm';

interface PublishGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmitEnd?: (idGroup?: string) => void;
  group?: Group;
}

export default function PublishGroupModal({
  isOpen = false,
  onClose,
  onSubmitEnd,
  group,
}: PublishGroupModalProps) {
  const title = useMemo(() => {
    return group ? `Editer le groupe ${group.name}` : 'Créer un nouveau groupe';
  }, [group]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      accentColor={'tournesol'}
      size={['full', 'xl']}
    >
      <ModalHeader>{title}</ModalHeader>
      <GroupForm group={group} onSubmitEnd={onSubmitEnd} />
    </Modal>
  );
}
